import React from 'react';
import FormikAutoValidate from 'Components/Forms/FormikAutoValidate';
import useEditorState from 'FeatureModules/ProductPage/hooks/useEditorState';

const AutoValidate = () => {
  const { showValidation } = useEditorState();

  return <FormikAutoValidate showValidation={showValidation} />;
};

export default AutoValidate;
